<span class="month-form">
<mat-form-field class="monthForm">
  <mat-label>{{label}}</mat-label>
  <input matInput disabled [matDatepicker]="dp"  [(ngModel)]="selectedDate" [min]="min" [max]="max" (dateChange)="chosenMonthHandler($event.value)">
  <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
  <mat-datepicker panelClass="filter-month-picker" #dp disabled="false" startView="year"
                  [calendarHeaderComponent]="customHeader">
  </mat-datepicker>
</mat-form-field>
</span>